import { handleAuthorization, handleOkResponseJson, handleBadRequest400 } from "./handlers"
import { obterToken } from "./loginService"

export const obterLocalizacoesAsync = async () => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Localizacao/obterLista`, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export const enviarLocalizacaoAsync = async (nome) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ nome })
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Localizacao`, requestOptions)
        .then(handleAuthorization)
        .then(handleBadRequest400);
}

export const editarLocalizacaoAsync = async (id, nome, ativo) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ id, nome, ativo })
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Localizacao/atualizar`, requestOptions)
        .then(handleAuthorization)
        .then(handleBadRequest400);
}
